"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
function FlaggProvider(_a) {
    var children = _a.children, featureFlags = _a.featureFlags;
    var _b = react_1.useState(0), iteration = _b[0], setIteration = _b[1];
    var ff = featureFlags;
    react_1.useEffect(function () {
        var originalSet = featureFlags.set;
        ff.set = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var rVal = originalSet.apply(void 0, args);
            setIteration(function (val) { return val + 1; });
            return rVal;
        };
    }, []);
    return (react_1.default.createElement(context_1.FlaggContext.Provider, { value: { featureFlags: ff, iteration: iteration } }, children));
}
exports.FlaggProvider = FlaggProvider;
//# sourceMappingURL=provider.js.map